import React, { useEffect, useState } from "react";
import "./Rules.css";

const RULE_TABS = [
  "Football",
  "Horse Racing",
  "E Games",
  "Basketball",
  "MotoGP",
  "Chess",
  "Volleyball",
  "Ice Hockey",
  "Tennis",
  "Badminton",
  "Cycling",
  "Mixed Martial Arts",
  "Motorbikes",
  "Athletics",
  "Basketball 3X3",
  "Sumo",
  "Virtual sports",
  "Handball",
];

const FOOTBALL_SECTIONS = [
  {
    title: "bookmaker",
    rows: [
      {
        text: "If the match will not take place within 48 hours of the original kick-off time bets will be void.",
      },
      {
        danger: true,
        text: "If the selection is in a multiple bet or accumulator any refund must be requested before kick-off of the first leg of the multiple bet.",
      },
      {
        danger: true,
        text: "Where a confirmed postponed match features as part of a multiple bet, the bet will stand on the remaining selections in the multiple.",
      },
      {
        text: "Please note that games which have their kick-off altered well in advance to accommodate live TV, or to ease fixture congestion will not be classed as postponed.",
      },
      {
        danger: true,
        text: "If a match is forfeited or a team is given a walkover victory without the match having kicked off, then all bets will be void. Any subsequently awarded scoreline will not count for settlement purposes.",
      },
    ],
  },
  {
    title: "match",
    rows: [
      {
        text: "Match Odds :- All bets apply to the relevant full 'regular time' period including stoppage time. Any extra-time and/or penalty shoot-out is not included. For the cancellation of a goal, due to VAR, bets matched between the time of the goal being scored and the time at which the video assistant referee finishes the review will be voided. For the cancellation of a red card, due to VAR, bets matched after the time at which the video assistant referee commences the review will be voided.",
      },
      {
        text: "Under_Over Goals :- In the event of a match starting but not being completed, all bets will be void, unless the specific market outcome is already determined.",
      },
      {
        text: "1st Period Winner :- Bets will be void if the match is abandoned before half-time.",
      },
      {
        text: "Next Goal :- Own goals count to the side credited with the goal.",
      },
      {
        text: "Draw No Bet :- Predict which team will be the winner. In case of a draw, all bets will be void.",
      },
    ],
  },
];

const GENERAL_SECTIONS = [
  {
    title: "general",
    rows: [
      {
        text: "These Rules and Regulations are part of the Site's terms and conditions and apply to all bets placed on this platform.",
      },
      {
        text: "The General Rules apply to all bets unless stated otherwise in the Specific Sports Rules.",
      },
      {
        text: "Customers must familiarise themselves with the relevant rules that apply to the bets they place on the Site.",
      },
    ],
  },
];

const RulesModal = ({ open, onClose }) => {
  const [activeTab, setActiveTab] = useState("Football");

  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  const sections =
    activeTab === "Football" ? FOOTBALL_SECTIONS : GENERAL_SECTIONS;

  return (
    <div className="rules-modal-backdrop" role="presentation">
      <section
        className="rules-modal-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="rules-modal-title"
      >
        <header className="rules-modal-header">
          <h2 id="rules-modal-title">Rules</h2>

          <div className="rules-modal-header-actions">
            <button type="button" className="rules-language-button">
              <span className="rules-language-flag" aria-hidden="true">
                🇬🇧
              </span>
              <span>English</span>
              <i className="fas fa-caret-down" aria-hidden="true" />
            </button>

            <button
              type="button"
              className="rules-modal-x"
              onClick={onClose}
              aria-label="Close rules"
            >
              ×
            </button>
          </div>
        </header>

        <div className="rules-modal-body">
          <nav className="rules-modal-tabs" aria-label="Rule categories">
            {RULE_TABS.map((tab) => (
              <button
                key={tab}
                type="button"
                className={`rules-modal-tab${activeTab === tab ? " active" : ""
                  }`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </nav>

          <div className="rules-modal-content">
            {sections.map((section) => (
              <section className="rules-content-section" key={section.title}>
                <h3>{section.title}</h3>
                <div className="rules-content-rows">
                  {section.rows.map((row, index) => (
                    <p
                      key={`${section.title}-${index}`}
                      className={row.danger ? "rules-danger" : ""}
                    >
                      {row.text}
                    </p>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </div>

        <footer className="rules-modal-footer">
          <button type="button" onClick={onClose}>
            Close
          </button>
        </footer>
      </section>
    </div>
  );
};

export default RulesModal;
